import { gql } from "@apollo/client";

const GET_DOCUMENT_TYPES = gql`
  query GetDeductionDocumentTypes {
    deductionDocumentTypes {
      count
      items {
        id
        typeName
        typeKey
      }
    }
  }
`;

export default GET_DOCUMENT_TYPES;
